import {
  IconAnalytics,
  IconBinocularsGray,
  IconChartBar,
  IconClockGray,
  IconCoil,
  IconLayers,
  IconLocation,
  IconMeter,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/logisticsAsset/video/sub/rtlsVideo4.mp4';

import image1 from '@src/assets/images/solution/logisticsAsset/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsAsset/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsAsset/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsAsset/img/4.avif';

export default {
  type: '物流ソリューション',
  banner: {
    title: '倉庫資産の移動を自動記録し、入出庫をリアルタイムで管理',
    desc: '資産の入出庫時点と移動経路を自動で追跡し、物流の流れをデジタル化。手作業なしで正確な在庫管理と異常検知が可能です。',
  },

  video: {
    title: '正確な位置データで物流倉庫の運営効率を向上',
    desc: '複雑な倉庫内でも個別資産の位置をリアルタイムで追跡し、資産管理の正確性と効率を最大化します。',
    play: video,
  },

  func: [
    {
      theme: '物流資産の位置を正確に追跡・管理',
      title: '資産位置のリアルタイムモニタリング',
      desc: '大規模な物流倉庫内でも、個別資産の位置を±50cm以内で正確に把握し、リアルタイムで資産状況と分布を確認できます。迅速で正確な在庫管理が可能です。',
      sub1: '高精度を提供',
      icon1: IconRulerGray,
      sub2: '迅速なデータ連携',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '超小型ステッカータグで資産管理を簡素化',
      desc: '資産に超小型のステッカータグを貼り付けることで、どんなサイズや形状の資産にも簡単に位置追跡システムを適用できます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度を提供',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '大規模資産管理に特化したシステム',
      desc: '1万点以上の在庫資産を同時にリアルタイムでモニタリング・管理でき、大規模な物流環境でも高い効率性を実現します。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: '資産位置検索と即時把握',
      desc: '強力な検索機能により、必要な資産の位置をすぐに確認でき、在庫管理の時間と手間を最小化します。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: subVideo3,
    },
    {
      theme: '資産データを活用して運用効率を高め、リスクを予防',
      title: 'リアルタイム入出庫状況把握',
      desc: '出庫・入庫など全ての物流状況をリアルタイムでモニタリングし、物流移動を正確に追跡して運用ミスを未然に防ぎます。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: subVideo4,
    },
    {
      title: '倉庫別適正在庫量モニタリング',
      desc: '各倉庫の在庫資産の適正量をリアルタイムで分析し、空間活用を最適化。倉庫スペース不足を事前に防止します。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      image: image4,
    },
    {
      title: '無断持ち出し・資産紛失防止アラート',
      desc: '資産が無断で持ち出されたり、指定時間外に移動が発生した場合、即座にアラートを送信し、資産紛失リスクを未然に防止します。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: subVideo1,
    },
    {
      title: '在庫状況リアルタイムモニタリング',
      desc: 'エリア別および全体の在庫状況をリアルタイムで直感的に把握でき、正確な在庫運用と迅速な意思決定を支援します。',
      sub1: '迅速なデータ連携',
      icon1: IconShareGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      video: subVideo2,
    },
  ],

  subfunc: {
    title: '主な機能概要',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '資産位置リアルタイム確認',
        desc: '倉庫内全ての資産位置をリアルタイムで正確に確認',
      },
      {
        icon: IconCoil,
        title: '超小型ステッカータグ提供',
        desc: '小型タグで様々な資産に簡単に貼り付けて位置追跡',
      },
      {
        icon: IconLayers,
        title: '大規模資産同時管理',
        desc: '1万点以上の資産を同時にリアルタイム管理可能',
      },
      {
        icon: IconSearch,
        title: '資産位置検索機能',
        desc: '必要な資産の位置を検索機能ですぐに確認',
      },
      {
        icon: IconRoute,
        title: 'リアルタイム入出庫状況把握',
        desc: '入庫・出庫状況をリアルタイムで正確にモニタリング',
      },
      {
        icon: IconChartBar,
        title: '倉庫別適正在庫量分析',
        desc: '倉庫別在庫量と空間余裕を分析し効率的に運営',
      },
      {
        icon: IconWarning,
        title: '無断持ち出し自動アラート',
        desc: '無断持ち出しや時間外移動を即時アラート',
      },
      {
        icon: IconMeter,
        title: '在庫状況リアルタイム確認',
        desc: '倉庫全体・エリア別在庫状況を直感的にリアルタイム把握',
      },
      {
        icon: IconRoute,
        title: '資産移動経路記録',
        desc: '資産の移動経路を自動で記録しデータ化',
      },
      {
        icon: IconAnalytics,
        title: '資産データレポート',
        desc: '資産移動データを自動で分析し定期的にレポート提供',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'logisticsSafety',
    },
    {
      data: 'constructionAsset',
    },
    {
      data: 'blogRTLS',
    },
    {
      data: 'blogForklift',
    },
  ],
};
